import { isHaveValue } from "./isHaveValue";

export const generateSlugContentCourse = (
  idBab: any,
  idSubBab: any,
  idPointSubBab: any
) => {
  let slug = "";
  if (
    isHaveValue(idBab) &&
    !isHaveValue(idSubBab) &&
    !isHaveValue(idPointSubBab)
  ) {
    slug = `${idBab}`;
  }
  if (
    isHaveValue(idBab) &&
    isHaveValue(idSubBab) &&
    !isHaveValue(idPointSubBab)
  ) {
    slug = `${idBab}-${idSubBab}`;
  }
  if (
    isHaveValue(idBab) &&
    isHaveValue(idSubBab) &&
    isHaveValue(idPointSubBab)
  ) {
    slug = `${idBab}-${idSubBab}-${idPointSubBab}`;
  }

  return slug;
};

export function generateSlugFromUrl(url: string): string {
  const parts = url.split("/").filter(Boolean); // buang string kosong
  if (parts.length < 2) return url.replace(/\//g, "-"); // fallback
  const lastTwo = parts.slice(-2); // ambil 2 terakhir
  return lastTwo.join("-");
}

// TypeScript version (works in modern browsers / Node)
export function generateSlug(text: string, maxLength = 200): string {
  if (!text) return "";

  // 1) normalize and remove diacritics
  let slug = text.normalize("NFKD").replace(/[\u0300-\u036F]/g, "");

  // 2) lower case
  slug = slug.toLowerCase();

  // 3) replace non-alphanumeric with hyphen
  slug = slug.replace(/[^a-z0-9]+/g, "-");

  // 4) trim hyphens from ends and collapse multiples
  slug = slug.replace(/^-+|-+$/g, "").replace(/-{2,}/g, "-");

  // 5) limit length
  if (slug.length > maxLength) {
    slug = slug.slice(0, maxLength);
    // remove trailing hyphen after slice
    slug = slug.replace(/-+$/g, "");
  }

  // fallback if empty
  if (!slug) {
    return Math.random().toString(36).slice(2, 10);
  }

  return slug;
}
